<zah-thuisverzorgers [initialPageRequest]="initialPageRequest"
                     [thuisverzorgersPage]="thuisverzorgersPage$ | async"
                     [zones]="zones$ | async"
                     [diensten]="diensten$ | async"
                     (thuisverzorgerClicked)="navigateToThuisverzorger($event)"
                     (deleteClicked)="deleteThuisverzorger($event)"
                     (addClicked)="navigateToAddThuisverzorger()"
                     (pageChange)="onPageChange($event)">
</zah-thuisverzorgers>
